/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../src/locale';

const defaultLocale = 'en-US';
const i18n = {
  "en-US": {
    "captcha": {
      "playaudio": "play audio",
      "needCaptcha": "Please enter captcha code"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "Zoom is protected by reCAPTCHA and the Google <a href=\"https://policies.google.com/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://policies.google.com/terms\"  target=\"_blank\">Terms of Service</a> apply."
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom is protected by hCaptcha and its <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Terms of Service</a> apply."
        }
      }
    }
  },
  "de-DE": {
    "captcha": {
      "playaudio": "Audio abspielen",
      "needCaptcha": "Captcha-Code eingeben"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "Zoom ist durch reCAPTCHA gesch\u00FCtzt und es gelten die <a href=\"https://policies.google.com/privacy\" target=\"_blank\">Datenschutzrichtlinien</a> und <a href=\"https://policies.google.com/terms\"  target=\"_blank\">AGBs</a>."
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom is protected by hCaptcha and its <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Terms of Service</a> apply."
        }
      }
    }
  },
  "es-ES": {
    "captcha": {
      "playaudio": "reproducir audio",
      "needCaptcha": "Introduzca el c\u00F3digo captcha"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "Zoom est\u00E1 protegido por reCAPTCHA y la <a href=\"https://policies.google.com/privacy\" target=\"_blank\">Pol\u00EDtica de privacidadol\u00EDtica de privacidad</a> y las <a href=\"https://policies.google.com/terms\"  target=\"_blank\">Condiciones de servicio</a> aplicables."
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom is protected by hCaptcha and its <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Terms of Service</a> apply."
        }
      }
    }
  },
  "fr-FR": {
    "captcha": {
      "playaudio": "lire l’audio",
      "needCaptcha": "Saisissez le code Captcha"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "Zoom est prot\u00E9g\u00E9 par syst\u00E8me reCAPTCHA. De plus, la <a href=\"https://policies.google.com/privacy\" target=\"_blank\">Politique de confidentialit\u00E9</a> et les <a href=\"https://policies.google.com/terms\"  target=\"_blank\">Conditions de service</a> s\u2019appliquent."
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom is protected by hCaptcha and its <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Terms of Service</a> apply."
        }
      }
    }
  },
  "id-ID": {
    "captcha": {
      "playaudio": "putar audio",
      "needCaptcha": "Masukkan kode captcha"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "Zoom dilindungi oleh reCAPTCHA dan memberlakukan <a href=\"https://policies.google.com/privacy\" target=\"_blank\">Kebijakan Privasi</a> dan <a href=\"https://policies.google.com/terms\"  target=\"_blank\">Ketentuan Layanan</a>."
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom dilindungi oleh hCaptcha dan memberlakukan <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Kebijakan Privasi</a> dan <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Ketentuan Layanan</a>."
        }
      }
    }
  },
  "it-IT": {
    "captcha": {
      "playaudio": "riproduci audio",
      "needCaptcha": "Inserisci il codice Captcha"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "Zoom \u00E8 protetto con reCAPTCHA e si applicano l\u2019<a href=\"https://policies.google.com/privacy\" target=\"_blank\">Informativa sulla privacy</a> e i <a href=\"https://policies.google.com/terms\"  target=\"_blank\">Termini di servizio</a>."
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom is protected by hCaptcha and its <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Terms of Service</a> apply."
        }
      }
    }
  },
  "jp-JP": {
    "captcha": {
      "playaudio": "オーディオを再生",
      "needCaptcha": "CAPTCHA\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "Zoom\u306FreCAPTCHA\u3067\u4FDD\u8B77\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u307E\u305F\u3001<a href=\"https://policies.google.com/privacy\" target=\"_blank\">\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC</a>\u3068<a href=\"https://policies.google.com/terms\"  target=\"_blank\">\u30B5\u30FC\u30D3\u30B9\u5229\u7528\u898F\u7D04</a>\u304C\u9069\u7528\u3055\u308C\u307E\u3059\u3002"
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom is protected by hCaptcha and its <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Terms of Service</a> apply."
        }
      }
    }
  },
  "ko-KO": {
    "captcha": {
      "playaudio": "오디오 재생",
      "needCaptcha": "Captcha \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694."
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "Zoom\uC740 reCAPTCHA\uB85C \uBCF4\uD638\uB418\uBA70, <a href=\"https://policies.google.com/privacy\" target=\"_blank\">\uAC1C\uC778\uC815\uBCF4 \uBCF4\uD638\uC815\uCC45</a> \uBC0F <a href=\"https://policies.google.com/terms\"  target=\"_blank\">\uC11C\uBE44\uC2A4 \uC57D\uAD00</a>\uC774 \uC801\uC6A9\uB429\uB2C8\uB2E4."
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom is protected by hCaptcha and its <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Terms of Service</a> apply."
        }
      }
    }
  },
  "nl-NL": {
    "captcha": {
      "playaudio": "audio afspelen",
      "needCaptcha": "Voer de captcha-code in"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "Zoom wordt beschermd door reCAPTCHA, en het <a href=\"https://policies.google.com/privacy\" target=\"_blank\">-privacybeleid</a> en de <a href=\"https://policies.google.com/terms\"  target=\"_blank\">-servicevoorwaarden</a> zijn van toepassing."
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom wordt beschermd door hCaptcha, en diens <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">-privacybeleid</a> en <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">-servicevoorwaarden</a> zijn van toepassing."
        }
      }
    }
  },
  "pl-PL": {
    "captcha": {
      "playaudio": "odtwarzaj głos",
      "needCaptcha": "Wprowadź kod captcha"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "Zoom jest chroniony przez reCAPTCHA i obowiązują <a href=\"https://policies.google.com/privacy\" target=\"_blank\">Polityka Prywatności</a> oraz <a href=\"https://policies.google.com/terms\"  target=\"_blank\">Warunki świadczenia usług</a>."
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom jest chroniony przez hCAPTCHA i obowiązują <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Polityka Prywatności</a> oraz <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Warunki świadczenia usług</a>."
        }
      }
    }
  },
  "pt-PT": {
    "captcha": {
      "playaudio": "reproduzir áudio",
      "needCaptcha": "Insira o c\u00F3digo captcha"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "O Zoom \u00E9 protegido pelo reCAPTCHA e aplicam-se a <a href=\"https://policies.google.com/privacy\" target=\"_blank\">Pol\u00EDtica de Privacidade</a> e os <a href=\"https://policies.google.com/terms\"  target=\"_blank\">Termos de Servi\u00E7o</a>."
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom is protected by hCaptcha and its <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Terms of Service</a> apply."
        }
      }
    }
  },
  "ru-RU": {
    "captcha": {
      "playaudio": "воспроизвести звук",
      "needCaptcha": "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 captcha"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "\u0414\u043B\u044F \u0437\u0430\u0449\u0438\u0442\u044B Zoom \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430 reCAPTCHA. \u041D\u0430 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Zoom \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u044F\u044E\u0442\u0441\u044F <a href=\"https://policies.google.com/privacy\" target=\"_blank\">\u043F\u043E\u043B\u0438\u0442\u0438\u043A\u0430 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438</a> \u0438 <a href=\"https://policies.google.com/terms\"  target=\"_blank\">\u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F</a>."
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom is protected by hCaptcha and its <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Terms of Service</a> apply."
        }
      }
    }
  },
  "tr-TR": {
    "captcha": {
      "playaudio": "sesi çal",
      "needCaptcha": "Lütfen captcha kodunu girin"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "Zoom, reCAPTCHA tarafından korunmaktadır ve <a href=\"https://policies.google.com/privacy\" target=\"_blank\">Gizlilik Politikası</a> ve <a href=\"https://policies.google.com/terms\"  target=\"_blank\">Hizmet Şartları</a> geçerlidir."
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom, hCaptcha tarafından korunmaktadır ve <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Gizlilik Politikası</a> ve <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Hizmet Şartları</a> geçerlidir."
        }
      }
    }
  },
  "vi-VN": {
    "captcha": {
      "playaudio": "phát âm thanh",
      "needCaptcha": "Vui l\u00F2ng nh\u1EADp m\u00E3 captcha"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "Zoom \u0111\u01B0\u1EE3c b\u1EA3o v\u1EC7 b\u1EB1ng reCAPTCHA v\u00E0 \u00E1p d\u1EE5ng <a href=\"https://policies.google.com/privacy\" target=\"_blank\">Ch\u00EDnh s\u00E1ch quy\u1EC1n ri\u00EAng t\u01B0</a> v\u00E0 <a href=\"https://policies.google.com/terms\"  target=\"_blank\">\u0110i\u1EC1u kho\u1EA3n d\u1ECBch v\u1EE5</a>."
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom is protected by hCaptcha and its <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Terms of Service</a> apply."
        }
      }
    }
  },
  "zh-CN": {
    "captcha": {
      "playaudio": "播放音频",
      "needCaptcha": "\u8BF7\u8F93\u5165\u56FE\u7247\u9A8C\u8BC1\u7801"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "Zoom\u53D7reCAPTCHA\u4FDD\u62A4\uFF0C\u5E76\u4E14\u9002\u7528<a href=\"https://policies.google.com/privacy\" target=\"_blank\">\u9690\u79C1\u653F\u7B56</a>\u548C<a href=\"https://policies.google.com/terms\"  target=\"_blank\">\u670D\u52A1\u6761\u6B3E</a>\u3002"
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom is protected by hCaptcha and its <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Terms of Service</a> apply."
        }
      }
    }
  },
  "zh-TW": {
    "captcha": {
      "playaudio": "播放音訊",
      "needCaptcha": "\u8ACB\u8F38\u5165captcha\u4EE3\u78BC"
    },
    "google": {
      "invisible": {
        "captcha": {
          "policy": "Zoom\u53D7\u5230reCAPTCHA\u4FDD\u8B77\uFF0C\u4E26\u4E14\u9069\u7528<a href=\"https://policies.google.com/privacy\" target=\"_blank\">\u96B1\u79C1\u6B0A\u653F\u7B56</a>\u53CA<a href=\"https://policies.google.com/terms\"  target=\"_blank\">\u670D\u52D9\u689D\u6B3E</a>\u3002"
        }
      }
    },
    "hcaptcha": {
      "invisible": {
        "captcha": {
          "policy": "Zoom is protected by hCaptcha and its <a href=\"https://hcaptcha.com/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://hcaptcha.com/terms\" target=\"_blank\">Terms of Service</a> apply."
        }
      }
    }
  }
};
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];

addLang(lang);
